import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { dataViewNotFound, getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import useQueryString from "@starter/Framework/Common/Hooks/useQueryString";
import { useSelector } from "react-redux";

const usePromotions = (options?: Toolkit.GoogleAnalytics.Options) => {
    const { cartId } = useQueryString();
    const promotionsDataView = useSelector((state: ApplicationState) => {
        const dataView =
            state.data.promotions.dataViews[getDataViewKey({ cartId: cartId || API_URL_CURRENT_FRAGMENT })];
        if (!dataView) {
            return dataViewNotFound;
        }

        return dataView as { value: PromotionModel[] | undefined };
    });

    return promotionsDataView.value;
};

export default usePromotions;
